import * as angular from "angular";
import {IController, IQService} from "angular";

export class paymentListCtrl implements IController {

  ids: any;
  textQuery: string;

  private commissionsRef: any;
  private payedCommissions: any;
  private selectedPaymentId: any;
  private loading: boolean;

  /* @ngInject */
  constructor(private $commission, private $q: IQService, private $log) {}

  $onInit() {
    this.commissionsRef = this.$commission();
    this.payedCommissions = [];
    this.selectedPaymentId = null;
    this.loading = false;
  }

  openPayment(payment) {
    this.selectedPaymentId = payment.id;
    this.loading = true;
    this.getCommissions(payment.commissionIds)
      .then((commissions) => {
        this.payedCommissions = commissions;
      })
      .catch((error) => {
        this.$log.error('Failed to get commissions', error);
      })
      .finally(() => {
        this.loading = false;
    })
  }

  onCloseExpanded() {
    this.payedCommissions = [];
    this.selectedPaymentId = null;
  }

  getCommissions(ids) {
    const deferred = this.$q.defer();
    this.commissionsRef.$asyncValues(ids)
      .then((commissions) => {
        deferred.resolve(commissions);
      })
      .catch((error) => {
        deferred.reject(error)
      });
    return deferred.promise;
  }

}
angular
  .module('bringoz.admin.payments')
  .component('paymentList', {
    bindings: {
      ids: '<',
      textQuery: '<'
    },
    template: require('./payment-list.html').default,
    controller: paymentListCtrl
  });
